import {AuthServerType} from "./auth-server-type";

export class ExternalLoginRequest {
  constructor(private authServerType: AuthServerType, private accessToken: string) {
  }
}
